import { supabase } from './supabase';
import type { MusicTrack } from './api';

export type NewMusicTrack = Omit<
  MusicTrack,
  'id' | 'created_at' | 'updated_at'
>;

const TABLE = 'music_tracks';

export async function listMusicTracks(
  includeInactive = false
): Promise<MusicTrack[]> {
  let query = supabase
    .from(TABLE)
    .select('*')
    .order('name', { ascending: true });

  if (!includeInactive) {
    query = query.eq('is_active', true);
  }

  const { data, error } = await query;

  if (error) throw error;
  return (data as MusicTrack[]) || [];
}

export async function createMusicTrack(
  input: NewMusicTrack
): Promise<MusicTrack> {
  const payload = {
    name: input.name,
    audio_url: input.audio_url,
    is_active: input.is_active,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .insert(payload)
    .select('*')
    .single();

  if (error) throw error;
  return data as MusicTrack;
}

export async function updateMusicTrack(
  id: string,
  input: NewMusicTrack
): Promise<MusicTrack> {
  const payload = {
    name: input.name,
    audio_url: input.audio_url,
    is_active: input.is_active,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .update(payload)
    .eq('id', id)
    .select('*')
    .single();

  if (error) throw error;
  return data as MusicTrack;
}

export async function deleteMusicTrack(id: string): Promise<void> {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);

  if (error) throw error;
}
